<template>
	<div class="it-services" :class="{ 'dark-theme': isDarkMode }">
		<h1 class="section-title">Konsultacje sztucznej inteligencji</h1>
		<p class="intro-text">
			Oferujemy zaawansowane rozwiązania IT, takie jak rozwój oprogramowania, zarządzanie infrastrukturą i
			wsparcie techniczne.
		</p>
		<section>
			<h1 class="section-title">Co mówi o sztucznej inteligencji ekspert</h1>
			<div class="expert-header">
				<img src="@/assets/tomasz-diakowski.png" alt="Tomasz Diakowski" class="expert-photo" />
				<div class="expert-info">
					<h2>Tomasz Diakowski</h2>
					<blockquote class="expert-quote">
						„Zacznij od małego projektu Sztucznej Inteligencji”
					</blockquote>
				</div>
			</div>
			<p>Zacznij z AI! Perspektywa Tomasza Diakowskiego</p>
			<div class="video-container">
				<iframe width="560" height="315" src="https://www.youtube.com/embed/bVxGn4JBLhU"
					title="Konsultacje AI - D4 Quality" frameborder="1"
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
					allowfullscreen></iframe>
			</div>
		</section>
		<section>
			<div class="expert-section">
				<div class="expert-content">
					<p>Tomasz Diakowski udzielił wywiadu o sztucznej inteligencji Pulsowi Biznesu. Posłuchajmy wspólnie
					</p>
					<div class="video-container">
						<iframe width="560" height="315"
							src="https://www.youtube.com/embed/xmdhVAb5qRw?si=lxkvWkNtCxwIIVEg"
							title="Wywiad Tomasza Diakowskiego dla Pulsu Biznesu" frameborder="0"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
							referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
export default {
	name: "Consulting",
	inject: ["theme"],
	data() {
		return {
			isDarkMode: localStorage.getItem("theme") === "dark",
			email: "", // Przechowuje e-mail użytkownika
		};
	},
	computed: {
		darkMode() {
			return this.theme && this.theme.isDarkMode ? this.theme.isDarkMode : this.isDarkMode;
		},
	},
	watch: {
		"theme.isDarkMode"(newVal) {
			this.isDarkMode = newVal;
			localStorage.setItem("theme", newVal ? "dark" : "light");
		},
	},
	methods: {
		submitLead() {
			// Tutaj możesz zaimplementować logikę wysyłania e-maila do backendu
			console.log("E-mail zapisany:", this.email);
			alert("Dziękujemy! Link do e-booka został wysłany na " + this.email);
			this.email = ""; // Reset pola
		},
	},
};
</script>

<style scoped>
.it-services {
	padding: 40px 20px;
	max-width: 1200px;
	margin: 0 auto;
	text-align: center;
	background-color: #ffffff;
	font-family: "Arial", sans-serif;
}

/* Nagłówek */
.section-title {
	font-size: 2.5rem;
	font-weight: 700;
	color: #007bff;
	margin-bottom: 20px;
}

/* Tekst wprowadzający */
.intro-text {
	font-size: 1.2rem;
	color: #333;
	line-height: 1.6;
	margin-bottom: 30px;
	max-width: 800px;
	margin-left: auto;
	margin-right: auto;
}

/* Kontener na wideo */
.video-container {
	position: relative;
	padding-bottom: 56.25%;
	height: 0;
	overflow: hidden;
	max-width: 100%;
	background: #000;
	border-radius: 12px;
	box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
}

.video-container iframe {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}

/* Nagłówek eksperta ze zdjęciem i cytatem */
.expert-header {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 30px;
	margin-bottom: 30px;
}

.expert-photo {
	width: 400px;
	height: 400px;
	object-fit: cover;
	border-radius: 50%;
	box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.expert-info {
	text-align: left;
}

.expert-quote {
	font-size: 1.3rem;
	font-style: italic;
	color: #007bff;
	margin-top: 10px;
	padding-left: 20px;
	border-left: 4px solid #007bff;
}

/* Sekcja eksperta */
.expert-section {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 30px;
	margin: 40px 0;
}

.expert-content {
	text-align: left;
	max-width: 600px;
}

/* Sekcja Lead Magnet */
.lead-magnet {
	margin: 40px 0;
	padding: 30px;
	background-color: #f5f5f5;
	border-radius: 12px;
}

.lead-text {
	font-size: 1.2rem;
	color: #333;
	margin-bottom: 20px;
}

.lead-form {
	display: flex;
	justify-content: center;
	gap: 10px;
}

.lead-input {
	padding: 10px;
	font-size: 1rem;
	border: 1px solid #ccc;
	border-radius: 6px;
	width: 300px;
}

.lead-button {
	padding: 10px 20px;
	font-size: 1rem;
	background-color: #007bff;
	color: #fff;
	border: none;
	border-radius: 6px;
	cursor: pointer;
}

.lead-button:hover {
	background-color: #0056b3;
}

/* Ciemny motyw */
.dark-theme.it-services {
	background-color: #1a1a1a;
}

.dark-theme .section-title {
	color: #007bff;
}

.dark-theme .intro-text,
.dark-theme .lead-text {
	color: #e0e0e0;
}

.dark-theme .video-container {
	box-shadow: 0 8px 20px rgba(255, 255, 255, 0.1);
}

.dark-theme .expert-photo {
	box-shadow: 0 4px 10px rgba(255, 255, 255, 0.2);
}

.dark-theme .expert-content p {
	color: #e0e0e0;
}

.dark-theme .expert-quote {
	color: #007bff;
	border-left-color: #007bff;
}

.dark-theme .lead-magnet {
	background-color: #2a2a2a;
}

.dark-theme .lead-input {
	background-color: #333;
	color: #e0e0e0;
	border-color: #555;
}

.dark-theme .lead-button {
	background-color: #007bff;
}

.dark-theme .lead-button:hover {
	background-color: #0056b3;
}

/* Responsywność */
@media (max-width: 768px) {
	.it-services {
		padding: 20px 10px;
	}

	.section-title {
		font-size: 2rem;
	}

	.intro-text,
	.lead-text {
		font-size: 1.1rem;
	}

	.video-container {
		padding-bottom: 75%;
	}

	.expert-header {
		flex-direction: column;
		gap: 20px;
	}

	.expert-photo {
		width: 150px;
		height: 150px;
	}

	.expert-info {
		text-align: center;
	}

	.expert-quote {
		font-size: 1.1rem;
		padding-left: 10px;
	}

	.expert-section {
		flex-direction: column;
		gap: 20px;
	}

	.expert-content {
		text-align: center;
	}

	.lead-form {
		flex-direction: column;
		gap: 15px;
	}

	.lead-input {
		width: 100%;
	}
}
</style>